import { categories } from "@/mocks/comics";

export default function Categories() {
  return (
    <section id="categories" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-xl">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <i className="ri-grid-fill"></i>
            题材分类
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">按题材，找到你的菜</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            分类清晰、标签细分，按口味精准筛选，快速定位喜欢的漫画类型。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href="#popular"
              className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-secondary-300 hover:bg-secondary-50"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-secondary-500 group-hover:text-background-50">
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <div className="min-w-0">
                <h3 className="whitespace-nowrap text-sm font-semibold text-foreground-950">{cat.name}</h3>
                <p className="mt-0.5 text-xs text-foreground-500">{cat.count} 部作品</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}